import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AUTH_STATUS, useAuthContext } from '../../context/authContext';
import LoginIcon from '@mui/icons-material/Login';

const Login = () => {
  const { user, signIn, authStatus } = useAuthContext();
  const navigate = useNavigate();
  const [searchParams, _] = useSearchParams();

  useEffect(() => {
    if (user) {
      const redirectTo = atob(searchParams.get('redirect_uri') || btoa('/'));
      navigate(redirectTo);
    }
  }, [user, searchParams]);

  const loading = useMemo(() => {
    console.log(authStatus);
    return [(AUTH_STATUS.NOT_INITIATED, AUTH_STATUS.LOADING)].includes(authStatus);
  }, [authStatus]);

  return (
    <div
      className="app background-image"
      style={{
        background: 'url("assets/images/brand-bg.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          overflow: 'scroll',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          width={250}
          height={150}
          boxShadow={2}
          padding={5}
          sx={{ opacity: 1, backgroundColor: 'white' }}
        >
          <Typography textAlign={'center'} mt={3} fontWeight={'bold'}>
            Log in to continue
          </Typography>
          <Box display={'flex'} justifyContent={'center'} mt={3}>
            <Button
              variant="contained"
              fullWidth
              startIcon={
                loading ? <CircularProgress size={21} sx={{ color: 'white' }} /> : <LoginIcon />
              }
              disabled={loading}
              onClick={signIn}
            >
              <Typography ml={1}>SSO Login</Typography>
            </Button>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default Login;
